import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import ChevronRightIcon from '@/assets/icon/ic_chevron_right.svg';
import { SccPressable } from '@/components/SccPressable';
import { color } from '@/constant/color';
import { cn } from '@/utils/cn';
import { useNavigation } from '@react-navigation/native';
import React, { useCallback } from 'react';
import { Text, View } from 'react-native';
import { formatDateRange } from '../utils/date';
export default function HistoryItem({ title, crusherClubId, startAt, endAt, historyType, isCurrentCrew, isFirst, }) {
    const navigation = useNavigation();
    const dateText = formatDateRange(startAt.value, endAt.value);
    const isCrewType = historyType === 'CREW';
    const handlePress = useCallback(() => {
        if (!crusherClubId) {
            return;
        }
        navigation.navigate('PastSeasonDetail', {
            crusherClubId,
            title,
        });
    }, [navigation, crusherClubId, title]);
    const content = (_jsxs(View, { className: cn('flex-row items-center gap-3 border-b-[1px] border-gray-20 px-5 py-[15px]', !!isFirst && !isCurrentCrew && 'border-t-[1px]'), children: [_jsx(View, { className: "flex-1 gap-[6px]", children: _jsxs(View, { className: "gap-[6px]", children: [_jsx(Text, { className: "font-pretendard-medium text-[18px] leading-[26px] text-gray-90", children: historyType === 'CONQUER_ACTIVITY_GUEST'
                                ? '정복활동 게스트 참여'
                                : title }), _jsx(Text, { className: "font-pretendard-regular text-[14px] leading-[20px] text-gray-50", children: dateText })] }) }), isCrewType && _jsx(ChevronRightIcon, { color: color.gray80 })] }));
    if (isCrewType && crusherClubId) {
        return (_jsx(SccPressable, { onPress: handlePress, elementName: "history-crew-item", children: content }));
    }
    return _jsx(View, { children: content });
}
